import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { useUserStore } from "../hooks";
import ConfirmDialog from "@/components/common/ConfirmDialog";

const DeleteUserDialog = observer(({ user, onClose }) => {
  const { t } = useTran();
  const { deleteLoading, markUserDeleted, loadUsers } = useUserStore();

  const handleConfirm = async () => {
    if (!user?.id) return { success: false };
    const result = await markUserDeleted(user.id);
    if (result) {
      onClose?.();
      await loadUsers();
    }
    return result;
  };

  return (
    <ConfirmDialog
      open={Boolean(user)}
      onOpenChange={(openState) => {
        if (!openState) {
          onClose?.();
        }
      }}
      title={t("Delete user")}
      description={t("This will mark your user as deleted.")}
      confirmLabel={t("Delete")}
      cancelLabel={t("Cancel")}
      onConfirm={handleConfirm}
      loading={deleteLoading}
      tone="danger"
    />
  );
});

export default DeleteUserDialog;
